import { _get, _getAxios, _getAxiosWithoutInterceptor } from './serviceMain';

export function getAllCustomerInfo(groupCode: string, storeCode: string, card: string) {

    const queryParams = new URLSearchParams({
        groupCode: groupCode,
        storeCode: storeCode,
        card: card
      });

    const url = '/v3/customer/all';

    return _getAxios(url, "GET_ALL_CUSTOMER_TIME", "allCustomerInfo",queryParams);
    
  };

  export function getAllCustomerInfo_Menu(groupCode: string, storeCode: string, card: string) {

    const queryParams = new URLSearchParams({
        groupCode: groupCode,
        storeCode: storeCode,
        card: card
      });

    const url = '/v3/customer/all';

     return _getAxiosWithoutInterceptor(url, "GET_ALL_CUSTOMER_TIME", "allCustomerInfo", queryParams);
    
  };